import Smartlook from 'smartlook-client';
import { getRuntimeConfig } from 'helpers/runtimeConfig';

const initializer = () => {
  Smartlook.init(getRuntimeConfig().env.REACT_APP_SMART_LOOK_ID);
};

export default initializer;
